<template>
  <div>
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; height: 100%; width: 100%;">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-if="!loading && exemptflags.length">
      <div 
        @click="showPermissionNotification(exempt_flag)" 
        :style="i < exemptflags.length - 1 ? 'border-bottom: 1px solid #e0e0e0;' : ''" 
        v-for="(exempt_flag, i) in exemptflags" 
        :key="'exempt_flag' + i"
      >
        <hb-form class="exempt-delinquency-items-form-input-wrapper" @cancel="cancel" :divider="false" :label="exempt_flag.name"
          :active.sync="active" :editable="!isClosed && hasEditPermission && isEditable(exempt_flag)" @save="openConfirmationModal(exempt_flag, i)">
          <!-- <template v-slot:tooltipBody>
            <div style="width: 250px">
              {{ exempt_flag.description | capitalize }}
            </div>
          </template> -->
          <template v-slot:display>
            <div class="mt-0 pt-0" :class="{ 'ml-4': isClosed }">
              <span v-if="showInfo && isEditable(exempt_flag)" class="hb-text-light">{{ getFlagInfo(exempt_flag) | capitalize }}</span>
              <HbCheckbox 
                class="mt-1 exempt_checkbox" 
                v-model="exempt_flag.status" 
                :label="getCheckboxLabel(exempt_flag) | capitalize" readonly 
                v-if="isEditable(exempt_flag)"
              />
              <span v-else > {{exempt_flag?.status? "Yes": "No"}} </span>
              <div v-if="exempt_flag?.status && isEditable(exempt_flag)" class="hb-text-light mt-1 mb-1">{{ exempt_flag.reason }}</div>
              <div v-if="exempt_flag?.modified_at && exempt_flag?.contact_name">
                <div class="text-body-2 hb-text-light mt-1">
                  Last Modified By: {{exempt_flag?.contact_name }} @ {{ exempt_flag?.modified_at | formatDateCustom('MMM DD, YYYY hh:mm A') | formatLocalDateTime }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:edit>
            <span v-if="showInfo" class="hb-text-light">{{ getFlagInfo(exempt_flag) | capitalize}}</span>
            <HbCheckbox 
              class="mt-1 exempt_checkbox" 
              v-model="exempt_flag.status" 
              :label="getCheckboxLabel(exempt_flag) | capitalize" 
            />
            <p style="color: #637381;" class="mb-2" v-if="exempt_flag.status && flagObjectType === FLAG_CHANGES_OBJECTS.EXEMPT_FLAG_TYPES.CONTACT">Provide a reason for adding the Tenant to the Do Not Rent list.</p>
            <HbTextarea 
              v-if="exempt_flag.status" 
              :rows=1
              row-height="15" 
              v-model="exempt_flag.reason"
              v-validate="'required|max:250'" 
              :maxlength="250" 
              data-vv-scope="flags" 
              placeholder="Reason* (250 limit)"
              placeholder-fix 
              full
            />
            <div v-if="exempt_flag?.modified_at && exempt_flag?.contact_name">
              <div class="text-body-2 hb-text-light">
                Last Modified By: {{
                  exempt_flag?.contact_name }} @ {{ exempt_flag?.modified_at | formatDateCustom('MMM DD, YYYY hh:mm A') | formatLocalDateTime }}
              </div>
            </div>
          </template>
        </hb-form>
        <hb-modal v-if="showConfirmation[i]" v-model="showConfirmation[i]" size="medium" :title='getConfirmationModelTitle(exempt_flag)' @close="cancel" confirmation>
          <template v-slot:content>
            <div class="py-4 px-6">
                {{ getConfirmationModelDescription(exempt_flag) }}
              <br /><br />
            </div>
          </template>
          <template v-slot:actions>
            <hb-btn :loading="saveFlagInProgress" :disabled="saveFlagInProgress" @click="saveLeaseExemptItems(exempt_flag, i)">Update Status</hb-btn>
          </template>
        </hb-modal>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import api from "../../assets/api.js";
import { EventBus } from "../../EventBus.js";
import { notificationMixin } from "@/mixins/notificationMixin.js";
import { mapMutations } from "vuex";
import { isEqual } from "lodash";
import FLAG_CHANGES_OBJECTS from '@/constants/flag_changes_objects.js';
import moment from 'moment';

export default {
  name: "ExemptItems",
  mixins: [notificationMixin],
  data() {
    return {
      active: "",
      oldExemptflags: [], 
      exemptflags: [], 
      showConfirmation: [],
      statusChanged: false,
      saveFlagInProgress: false,
      loading: true
    };
  },
  props: {
    flagObject: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    flagObjectType: {
      type: String,
      required: true,
      default: "lease",
    },
    isClosed: {
      type: Boolean,
      default: false
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    hasEditPermission: {
      type: Boolean,
      default: true
    },
    checkboxLable: {
      type: String,
      default: ""
    },
    confirmationModalTitle: {
      type: String,
      default: ""
    },
  },
  created(){
    this.FLAG_CHANGES_OBJECTS = FLAG_CHANGES_OBJECTS;
    EventBus.$on("reload_tenant_profile_leases", this.fetchLeaseExemptFlagsDetails);
  },
  async mounted() {
    try { 
      await this.fetchLeaseExemptFlagsDetails(); 
    } catch (error) {
      this.showMessageNotification({ description: error });
    }
  },
  destroyed(){
    EventBus.$off("reload_tenant_profile_leases", this.fetchLeaseExemptFlagsDetails);
  },
  methods: {
    ...mapMutations({
        setRefreshTenantProfile: 'tenantProfile/setRefreshTenantProfile',
    }),
    showPermissionNotification(exempt_flag){
      if(!this.hasEditPermission){
        this.showMessageNotification({ description: `You don\'t have enough permissions to update ${exempt_flag.name}.` });
        return;
      }
    },
    getConfirmationModelTitle(exempt_flag){
      if(this.confirmationModalTitle){
        return this.confirmationModalTitle;
      }
      return `Update ${exempt_flag?.name ? exempt_flag.name : 'flag exempt'}`;
    },
    getConfirmationModelDescription(exempt_flag){
      if(this.flagObjectType === FLAG_CHANGES_OBJECTS.EXEMPT_FLAG_TYPES.CONTACT){
        return `Are you sure you want to update the selected contact's Do Not Rent status?`;
      }else{
        return `Are you sure you want to update the selected ${this.flagObjectType } ${ exempt_flag?.name }?`;
      }
    },
    getCheckboxLabel(exempt_flag){
      if(this.checkboxLable){
         return this.checkboxLable;
      }
      return `Mark tenant as ${exempt_flag?.name ? exempt_flag.name : 'flag exempt'}`;
    },
    getFlagInfo(exempt_flag){
      if(exempt_flag?.slug === FLAG_CHANGES_OBJECTS.LEASE_FLAGS.EXEMPT_DELINQUENCY){
        return 'Checking this box means the tenant will be exempt from delinquency and will not trigger automated delinquency actions moving forward.';
      }else{
        return `Checking this box means that the tenant will be ${exempt_flag?.name ? exempt_flag.name : 'Flag Exempt'} moving forward.`;
      }
    },
    cancel() {
      this.exemptflags = JSON.parse(JSON.stringify(this.oldExemptflags));
      this.$emit('cancel');
    },
    async fetchLeaseExemptFlagsDetails(){
      this.loading = true;
      try {
        let r = await api.get(
          this,
          api.FLAG_CHANGES_OBJECTS + "flag-types-details/" + this.flagObjectType + "/" + this.flagObject.id
        );
        this.exemptflags = r.flags;
        this.oldExemptflags = JSON.parse(JSON.stringify(r.flags));
        this.loading = false;
      }
      catch (error) {
        this.showMessageNotification({ description: error });
        this.loading = false;
      }
    },
    async openConfirmationModal(exempt_flag, i){
      if (exempt_flag?.status && (!exempt_flag?.reason || exempt_flag.reason.trim() === '')) {
        this.showMessageNotification({ description: 'Please enter reason for status change' });
        return;
      }
      this.$set(this.showConfirmation, i, true);
    },
    async saveLeaseExemptItems(updatedFlag, i) {
      this.saveFlagInProgress = true;
      let prevFlag = this.oldExemptflags.length && this.oldExemptflags.find(exemptflag => exemptflag.id == updatedFlag?.id);
      let status = updatedFlag?.status ? 1 : 0;
      this.statusChanged = (prevFlag?.status !== status) ? true : false;
      if(!isEqual(prevFlag, updatedFlag)){
         try {
            let data = {
              flag_value: updatedFlag.status,
              description: updatedFlag.reason,
              is_flag_value_changed: this.statusChanged ? true : false,
              browser_timestamp: moment.utc().local().format('MMM DD, YYYY hh:mm A'),
            };
            let r = await api.post(
              this,
              api.FLAG_CHANGES_OBJECTS + this.flagObject.id + "/flag-type/" + this.flagObjectType + "/" + updatedFlag.flag_type_id, 
              data
            );
            if (r.flag) {
              this.showObjectTypeMessageSuccessNotification(this.flagObjectType, updatedFlag, this.statusChanged); 
              if(this.flagObjectType === FLAG_CHANGES_OBJECTS.EXEMPT_FLAG_TYPES.CONTACT){
                EventBus.$emit('refresh-contact-profile');
                EventBus.$emit('refetch_data');
                EventBus.$emit('contact_updated');
              } else{
                EventBus.$emit('reload_tenant_profile_leases');
                EventBus.$emit('reload_tenant_profile_delinquencies');
              }
              this.active = '';
            }
          }
          catch (error) {
            this.showMessageNotification({ description: error });
          }
      }
      this.$set(this.showConfirmation, i, false); 
      this.saveFlagInProgress = false
    },

    showObjectTypeMessageSuccessNotification(flagObjectType, updatedFlag, statusChanged){
      if(flagObjectType === FLAG_CHANGES_OBJECTS.EXEMPT_FLAG_TYPES.CONTACT){
        if(!statusChanged){  
          this.showMessageNotification({ type: 'success', description: `You have successfully updated the ${this.flagObject?.first} ${this.flagObject?.last} ${updatedFlag.name} Status.` });
        }else if(statusChanged && updatedFlag.status !== true){
          this.showMessageNotification({ type: 'success', description: `You have successfully removed ${this.flagObject?.first} ${this.flagObject?.last} from the ${updatedFlag.name} list.` });
        }else{
          this.showMessageNotification({ type: 'success', description: `You have successfully added ${this.flagObject?.first} ${this.flagObject?.last} to the ${updatedFlag.name} list.` });
        }
      }else{
        this.showMessageNotification({ type: 'success', description: `You have successfully updated the ${this.flagObjectType} ${updatedFlag.name} Status.` });
      } 
    },
    convertToPropertyDateTime(date){
      let leasePropertyDate = this.getPropertyDateTime(this.lease?.Unit?.property_id,this.properties, date);
      return leasePropertyDate ? leasePropertyDate : date;
    },
    isEditable(exempt_flag){
        return !([FLAG_CHANGES_OBJECTS.LEASE_FLAGS.BLOCK_COMMUNICATION].includes(exempt_flag.slug));
    },
  },
  watch: {
    flagObject() {
      this.fetchLeaseExemptFlagsDetails();
    },
  }
};

</script>

<style scoped>
  .protected-item .v-label {
    margin-top: 0px !important;
  }

  .exempt-delinquency-items-form-input-wrapper .v-input--selection-controls:not(.v-input--is-label-active) .v-input--selection-controls__input>i.v-icon,
  .hb-aviary-v-checkbox.v-input--selection-controls.v-input--is-disabled:not(.v-input--is-label-active) .v-input--selection-controls__input>i.v-icon {
    color: #DFE3E8 !important;
  }
  .exempt_checkbox label > div > span{
    margin-top: 3px !important;
  }

</style>
